export default __webpack_public_path__ + "assets/png/7483f496c86e389c2f6305590f43ac50.png";